/**
 * Product → analytics item mapper.
 * Prices arrive as strings like "€145" — normalize to a numeric EUR value.
 */

const CURRENCY = "EUR";

export function parsePriceEur(str) {
  return parseInt(String(str || "").replace(/\D/g, ""), 10) || 0;
}

export function toAnalyticsItem(product, quantity = 1, index, size) {
  return {
    item_id: String(product.slug),
    item_name: product.name,
    item_brand: "YABA",
    item_category: "Jellabas",
    item_variant: [product.print, size].filter(Boolean).join(" / ") || undefined,
    price: parsePriceEur(product.price),
    quantity: Number(quantity),
    ...(index === undefined ? {} : { index }),
  };
}

export function cartLinesToItems(lines) {
  // `lines` is the enriched items array from useCart(): { product, qty, size, ... }
  return lines.map((line, i) =>
    toAnalyticsItem(line.product, line.qty, i, line.size)
  );
}

export function cartValue(lines) {
  return lines.reduce(
    (a, l) => a + parsePriceEur(l.product.price) * l.qty,
    0
  );
}

export { CURRENCY };
